import * as React from 'react';
import Checkbox, { CheckboxProps } from './Checkbox';
import '../../../styles/Checkbox.css';

interface Props extends CheckboxProps {
    labelProps: {
        labelText: string;
    };
}

const CheckboxLabeled = (props: Props) => (
    <div className={'form-group' + (props.controlCssClass ? ` ${props.controlCssClass}` : '')}>
        <Checkbox {...props} />
        <label htmlFor={props.inputProps.id} className="font-weight-bold checkbox-label">
            {props.labelProps.labelText}
        </label>
    </div>
);

export default CheckboxLabeled;



// WEBPACK FOOTER //
// ./src/components/common/form/CheckboxLabeled.tsx